"use client"
import React, { useState } from "react";
import { ChevronDown, ChevronUp, ExternalLink, Github,  Code } from 'lucide-react';
import "./ProjectPage.css";
import NotelyScreenshot from '../assets/screenshot1.png';
import Scrapipy from '../assets/screenshot2.png';
import Naradly from '../assets/screenshot3.png';
import SpecScoreX from '../assets/screenshot4.png';


const ProjectPage = () => {
  const [expandedProject, setExpandedProject] = useState(null);

  const toggleProject = (projectId) => {
    setExpandedProject(expandedProject === projectId ? null : projectId);
  };

  return (
    <div className="project-container">
      <div className="project-header">
        <span>pro</span>jects
      </div>
      <div className="project-list">
        
        {/* Project 1 - Notely */}
        <div className="project">
          <div className="project-main" onClick={() => toggleProject(1)}>
            <p>Note Taking Web Application</p>
            <p>Notely</p>
            <p>
              <span>2025</span>
              <a href="https://trynotely.netlify.app/" onClick={(e) => e.stopPropagation()}>Tap to view</a>
              <div className={`chevron ${expandedProject === 1 ? 'expanded' : ''}`}>
                {expandedProject === 1 ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </p>
            <div className={`animated-border ${expandedProject === 1 ? 'expanded' : ''}`}></div>
          </div>
          
          <div className={`project-details ${expandedProject === 1 ? 'expanded' : ''}`}>
            <div className="project-content">
              <div className="project-image">
                  <img src={NotelyScreenshot} alt="Notely Screenshot" className="project-screenshot" />
              </div>

              <div className="section">
                <h4>About</h4>
                <p>A modern, intuitive note-taking application built with React and Firebase. Features real-time synchronization, rich text editing, and organizational tools to help users manage their thoughts and ideas efficiently.</p>
              </div>

              <div className="section">
                <h4>Technologies Used</h4>
                <div className="tech-tags">
                  <span className="tech-tag">React</span>
                  <span className="tech-tag">Firebase</span>
                  <span className="tech-tag">CSS3</span>
                  <span className="tech-tag">JavaScript</span>
                </div>
              </div>

              <div className="section">
                <h4>Key Features</h4>
                <div className="features-grid">
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Real-time note synchronization</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Rich text editor with formatting options</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Tag-based organization system</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Search functionality</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Responsive design for all devices</span>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <a href="https://trynotely.netlify.app/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <ExternalLink size={16} />
                  View Live Project
                </a>
                <a href="https://github.com/akarshmi/notely" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <Github size={16} />
                  View Source Code
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 2 - SpecScoreX */}
        <div className="project">
          <div className="project-main" onClick={() => toggleProject(2)}>
            <p>Device Specs Viewer</p>
            <p>SpecScoreX</p>
            <p>
              <span>2025</span>
              <a href="https://specscorex.onrender.com/" onClick={(e) => e.stopPropagation()}>Tap to view</a>
              <div className={`chevron ${expandedProject === 2 ? 'expanded' : ''}`}>
                {expandedProject === 2 ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </p>
            <div className={`animated-border ${expandedProject === 2 ? 'expanded' : ''}`}></div>
          </div>
          
          <div className={`project-details ${expandedProject === 2 ? 'expanded' : ''}`}>
            <div className="project-content">
              <div className="project-image">
                  <img src={SpecScoreX} alt="SpecScoreX Screenshot" className="project-screenshot" />
              </div>

              <div className="section">
                <h4>About</h4>
                <p>A comprehensive device specification viewer and comparison tool. Allows users to view detailed hardware specifications, compare devices side-by-side, and make informed purchasing decisions.</p>
              </div>

              <div className="section">
                <h4>Technologies Used</h4>
                <div className="tech-tags">
                  <span className="tech-tag">Node.js</span>
                  <span className="tech-tag">Express</span>
                  <span className="tech-tag">MongoDB</span>
                  <span className="tech-tag">React</span>
                </div>
              </div>

              <div className="section">
                <h4>Key Features</h4>
                <div className="features-grid">
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Detailed device specifications database</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Side-by-side device comparison</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Performance scoring system</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Price tracking and alerts</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>User reviews and ratings</span>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <a href="https://specscorex.onrender.com/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <ExternalLink size={16} />
                  View Live Project
                </a>
                <a href="https://github.com/akarshmi/specscorex" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <Github size={16} />
                  View Source Code
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 3 - Scrapipy */}
        <div className="project">
          <div className="project-main" onClick={() => toggleProject(3)}>
            <p>Web Scraping using AI</p>
            <p>Scrapipy</p>
            <p>
              <span>2024-25</span>
              <a href="https://scrapipy.streamlit.app/" onClick={(e) => e.stopPropagation()}>Tap to view</a>
              <div className={`chevron ${expandedProject === 3 ? 'expanded' : ''}`}>
                {expandedProject === 3 ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </p>
            <div className={`animated-border ${expandedProject === 3 ? 'expanded' : ''}`}></div>
          </div>
          
          <div className={`project-details ${expandedProject === 3 ? 'expanded' : ''}`}>
            <div className="project-content">
               <div className="project-image">
                  <img src={Scrapipy} alt="Scrapipy Screenshot" className="project-screenshot" />
              </div>

              <div className="section">
                <h4>About</h4>
                <p>An intelligent web scraping tool powered by AI that can automatically identify and extract data from websites. Uses machine learning to adapt to different website structures and formats.</p>
              </div>

              <div className="section">
                <h4>Technologies Used</h4>
                <div className="tech-tags">
                  <span className="tech-tag">Python</span>
                  <span className="tech-tag">Streamlit</span>
                  <span className="tech-tag">BeautifulSoup</span>
                  <span className="tech-tag">Selenium</span>
                  <span className="tech-tag">AI/ML</span>
                </div>
              </div>

              <div className="section">
                <h4>Key Features</h4>
                <div className="features-grid">
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>AI-powered content recognition</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Adaptive scraping algorithms</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Multiple output formats (CSV, JSON, XML)</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Rate limiting and ethical scraping</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Visual data preview and validation</span>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <a href="https://scrapipy.streamlit.app/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <ExternalLink size={16} />
                  View Live Project
                </a>
                <a href="https://github.com/akarshmi/scrapipy" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <Github size={16} />
                  View Source Code
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 4 - Naradly */}
        <div className="project">
          <div className="project-main" onClick={() => toggleProject(4)}>
            <p>Anonymous Chat Application</p>
            <p>Naradly</p>
            <p>
              <span>2024</span>
              <a href="https://github.com/akarshmi/Naradly" onClick={(e) => e.stopPropagation()}>Tap to view</a>
              <div className={`chevron ${expandedProject === 4 ? 'expanded' : ''}`}>
                {expandedProject === 4 ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </p>
            <div className={`animated-border ${expandedProject === 4 ? 'expanded' : ''}`}></div>
          </div>
          
          <div className={`project-details ${expandedProject === 4 ? 'expanded' : ''}`}>
            <div className="project-content">
              <div className="project-image">
                  <img src={Naradly} alt="Notely Screenshot" className="project-screenshot" />
              </div>

              <div className="section">
                <h4>About</h4>
                <p>A secure anonymous chat platform that prioritizes user privacy. Features end-to-end encryption, temporary chat rooms, and no data retention policies to ensure complete anonymity.</p>
              </div>

              <div className="section">
                <h4>Technologies Used</h4>
                <div className="tech-tags">
                  <span className="tech-tag">React</span>
                  <span className="tech-tag">Socket.io</span>
                  <span className="tech-tag">Node.js</span>
                  <span className="tech-tag">Express</span>
                  <span className="tech-tag">Encryption</span>
                </div>
              </div>

              <div className="section">
                <h4>Key Features</h4>
                <div className="features-grid">
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>End-to-end encryption</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Anonymous user sessions</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Temporary chat rooms</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>No message history retention</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Real-time messaging</span>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <a href="/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <ExternalLink size={16} />
                  View Live Project
                </a>
                <a href="https://github.com/akarshmi/naradly" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <Github size={16} />
                  View Source Code
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Project 5 - College Management System */}
        <div className="project">
          <div className="project-main" onClick={() => toggleProject(5)}>
            <p>Java GUI Based Management System</p>
            <p>College Management System</p>
            <p>
              <span>2023-24</span>
              <a href="https://github.com/akarshmi/College-Management-System" onClick={(e) => e.stopPropagation()}>Tap to view</a>
              <div className={`chevron ${expandedProject === 5 ? 'expanded' : ''}`}>
                {expandedProject === 5 ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </p>
            <div className={`animated-border ${expandedProject === 5 ? 'expanded' : ''}`}></div>
          </div>
          
          <div className={`project-details ${expandedProject === 5 ? 'expanded' : ''}`}>
            <div className="project-content">
              <div className="project-image">
                <Code size={64} className="code-icon" />
                <p>Project Screenshot</p>
                <p className="image-subtitle">College Management System</p>
              </div>

              <div className="section">
                <h4>About</h4>
                <p>A comprehensive college management system built with Java Swing. Handles student enrollment, course management, grade tracking, and administrative tasks with an intuitive desktop interface.</p>
              </div>

              <div className="section">
                <h4>Technologies Used</h4>
                <div className="tech-tags">
                  <span className="tech-tag">Java</span>
                  <span className="tech-tag">Swing</span>
                  <span className="tech-tag">MySQL</span>
                  <span className="tech-tag">JDBC</span>
                </div>
              </div>

              <div className="section">
                <h4>Key Features</h4>
                <div className="features-grid">
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Student enrollment and management</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Course scheduling and tracking</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Grade management system</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Faculty administration panel</span>
                  </div>
                  <div className="feature-item">
                    <div className="feature-bullet"></div>
                    <span>Report generation and analytics</span>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <a href="https://github.com/akarshmi/College-Management-System" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <ExternalLink size={16} />
                  View Live Project
                </a>
                <a href="https://github.com/akarshmi/College-Management-System" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <Github size={16} />
                  View Source Code
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProjectPage;
